export default __webpack_public_path__ + "static/media/Ataur1.04425760.png";